



















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";
import moment from "moment";

@Component({
  components: {}
})
export default class CpoTglPemberianModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm: string;

  tglCPO = moment().format("YYYY-MM-DD");
  today = moment().format("YYYY-MM-DD");
  loading = false;
  listObat = [];

  tgl = false;

  mounted() {}

  get headers() {
    return [
      { text: "No", value: "index", width: "35px" },
      { text: "Nama Obat", value: "nama", width: "150px" },
      {
        text: "Dosis Resep",
        value: "dosis_resep",
        width: "50px",
        align: "center"
      },
      { text: "Dosis CPO", value: "dosis_cpo", width: "50px", align: "center" },
      // {
      //   text: "waktu Pemberian",
      //   value: "waktu",
      //   width: "50px",
      //   align: "center"
      // },
      { text: "Pilih", value: "check", width: "30px", align: "center" }
    ];
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  close() {
    this.dialog = false;
    this.listObat = [];
    this.tglCPO = moment().format("YYYY-MM-DD");
  }

  cariCPO() {
    if (!this.loading) {
      this.listObat = [];
      this.loading = true;
      SvcCatatanPemberianObat.getPemberianByTgl(this.register, this.tglCPO)
        .then(resp => {
          console.log(resp);
          this.tempel(resp);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  tempel(val) {
    this.listObat = [];
    if (val.length > 0) {
      val.forEach(item => {
        if (item.racik == "0") {
          const resep_dosis = item.item.resep_dosis
            ? item.item.resep_dosis
            : "";
          const resep_frekuensi = item.item.resep_frekuensi
            ? item.item.resep_frekuensi
            : "";
          const dt = {
            id: item.obat.KODE,
            nama: item.obat.NAMA,
            ket: null,
            dosis_cpo: item.dosis_text,
            dosis_resep: resep_dosis + " " + resep_frekuensi,
            date: item.date,
            time: item.time,
            check: true
          };
          this.listObat.push(dt);
        } else {
          const racik = item.detail_racik;
          racik.forEach(rck => {
            const resep_dosis = item.item.resep_dosis
              ? item.item.resep_dosis
              : "";
            const resep_frekuensi = item.item.resep_frekuensi
              ? item.item.resep_frekuensi
              : "";
            const dt = {
              id: rck.kode_obat,
              nama: rck.nama,
              ket: item.obat.NAMA,
              dosis_cpo: item.dosis_text,
              dosis_resep: resep_dosis + " " + resep_frekuensi,
              date: item.date,
              time: item.time,
              check: true
            };
            this.listObat.push(dt);
          });
        }
      });
    }
  }

  ambil() {
    const selectedObat = this.listObat.filter(item => item.check);
    this.$emit("tempel", selectedObat);
    this.dialog = false;
    this.tglCPO = moment().format("YYYY-MM-DD");
    this.listObat = [];
  }

  formatHumanDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD MMMM YYYY") : "";
  }
}
